import React, { Component } from 'react';
import { connect } from 'react-redux';

import { currentUserRole } from '../../util';

import EmployeeSidebarNav from './employeeSidebarNav';
import ManagerSidebarNav from './managerSidebarNav';

class SidebarNav extends Component{

  render(){

    if(this.props.viewingUser.loading){
      return null;
    }
    else if(this.props.viewingUser.data){
      return <ManagerSidebarNav />
    }
    else{
      return <EmployeeSidebarNav />
    }
  }
}

function mapStateToProps(state, ownProps){
  return {
    viewingUser: state.viewingUser,
  }
}

export default connect(mapStateToProps, {})(SidebarNav);



// WEBPACK FOOTER //
// ./src/components/shared/sidebarNav.js